import NewCalendar from './NewCalendar';

export { NewCalendar };
export default NewCalendar;
